import React, { memo, useEffect , useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import "./homePage.scss";
import { RightOutlined } from "@ant-design/icons";
import styled , { css }  from "styled-components";
import { FormattedMessage } from "react-intl";
import { getNameStatisticGeneralInfo } from "../../slices/storeSlice";
import { Lang } from "../../types/common";
import SearchBar from "../../containers/SearchBar";
import DSEClogo from "../../containers/DSEClogo";
import Loading from "../../containers/Loading";
import Part1 from "../../containers/Part1";
import Part2 from "../../containers/Part2";
import Part3 from "../../containers/Part3";
import Part4 from "../../containers/Part4";
import Part5 from "../../containers/Part5";
import Part6 from "../../containers/Part6";
import DSI from "../../containers/DSI";
import { RootState, AppDispatch } from "../../store";
import { useShallowEqualSelector } from "../../modules/hooks";


//region style
const TitleIcon = styled.a`
  background-image: url("${process.env.PUBLIC_URL}/images/title.png");
  background-size: cover;
  cursor: pointer;

  ${(props) => {
    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        width: 320px;
        height: 82px;
      `;
    }
    else
    {
      return css`
        width: 410px;
        height: 105px;
      `;
    }
  }}
`;

const Outline = styled.p`
  font-size: 22px;
  text-align: center;
  font-weight: bold;
  color: #106b64;
  margin-top: 50px;
  margin-bottom: 50px;
  span {
    font-size: 35px;
  }
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        padding: 0 40px;
      `;
    }
  }}
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #064645;
  margin-top: 150px;
  margin-bottom: 45px;
`;

const LoadingContainer = styled.div`
  position: relative;
  min-height: 200px;
`
//endregion
/*
*/
function HomePage() {
    const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
    return (
        <>
            <SearchBar/>
            <DSEClogo/>
            <TitleIcon href="https://dsec.gov.mo/NameStatistic/"/>
            {
                !generalInfo && <LoadingContainer>
                    <Loading></Loading>
                </LoadingContainer>
            }
            {
                generalInfo && <>
                    <Outline>澳門<span>百家姓、</span>熱門新生<span>嬰兒名字、最常用名字</span>人數···</Outline>
                    <Part1/>
                    <Part2/>
                    <Part3/>
                    <Part4/>
                    <Part5/>
                    <Part6/>
                    <DSI/>
                </>
            }
        </>
    );
}

export default memo(HomePage);
